export const SAFETY_TIMEOUT_MS = 60_000;
export const MAX_TEXTAREA_HEIGHT = 120;
export const MAX_STORED_MODES = 100;
